import { Flex } from '@/components/base';

import ChartDetailControllerSection from './body.controller-section';
import ChartDetailRenderSection from './body.render-section';

type Props = {
  chartInfo: ChartContextProps;
};

export function ChartDetailBody({ chartInfo }: Props) {
  return (
    <Flex className="flex-1 w-full overflow-auto">
      <ChartDetailControllerSection chartInfo={chartInfo} />
      <ChartDetailRenderSection chartInfo={chartInfo} />
    </Flex>
  );
}
